var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00021 0C3.32061 0 1.14062 2.17999 1.14062 4.85959C1.14062 5.96527 1.50297 7.00657 2.1885 7.87093C3.07613 8.99009 5.6574 11.6474 5.76683 11.7599L6.00018 12L6.23356 11.76C6.34306 11.6474 8.9251 8.98947 9.81286 7.86995C10.4978 7.00628 10.8598 5.96533 10.8598 4.85959C10.8598 2.17999 8.67981 0 6.00021 0ZM9.30278 7.46546C8.58811 8.36666 6.66885 10.3714 6.00021 11.0648C5.33164 10.3715 3.41306 8.36728 2.69856 7.4664C2.10524 6.71828 1.79162 5.81687 1.79162 4.85959C1.79162 2.53895 3.67957 0.650996 6.00021 0.650996C8.32082 0.650996 10.2088 2.53895 10.2088 4.85959C10.2088 5.81694 9.89548 6.71805 9.30278 7.46546Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9996 1.92908C4.41345 1.92908 3.12305 3.21948 3.12305 4.80563C3.12305 6.39178 4.41348 7.68219 5.9996 7.68219C7.58572 7.68219 8.87616 6.39175 8.87616 4.80563C8.87616 3.21951 7.58575 1.92908 5.9996 1.92908ZM5.9996 7.03119C4.77241 7.03119 3.77404 6.03279 3.77404 4.80563C3.77404 3.57844 4.77244 2.58007 5.9996 2.58007C7.22676 2.58007 8.22513 3.57847 8.22516 4.80563C8.22516 6.03282 7.22679 7.03119 5.9996 7.03119Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.a7e48085.svg";
export { ForwardRef as ReactComponent };